<template>
  <article
    class="bq-card"
    :class="[{ 'bq-card-link': isLink }, { mobile: isMobile }]"
    @click="handleRouterPush(isLink, link)"
  >
    <div class="bq-card-cover" v-if="cover">
      <img :src="cover" alt="title" />
      <div class="bq-content-wrap">
        <h3 v-if="title">{{ title }}</h3>
        <p v-if="coverContent">{{ coverContent }}</p>
      </div>
    </div>

    <div class="bq-card-content" :class="{ link: isLink }">
      <!-- card 封面插槽 -->
      <slot name="cover"></slot>
      <!-- 扩展插槽 -->
      <slot name="extra"></slot>
    </div>
  </article>
</template>

<script>
import { isWirelessDevice } from '../../../utils/utils';

export default {
  name: 'BQHorizontalCard',

  props: {
    cover: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    coverContent: {
      type: String,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    link: String, // 内容区域的点击
  },

  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    handleRouterPush(isLink, path) {
      if (!isLink) {
        return;
      }

      // this.$router.push(path);
      location.href = path;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
